import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Button,
  Col,
  Form,
  Card,
  CardGroup,
  Table,
} from "react-bootstrap";
import { FaEdit } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { TiPrinter } from "react-icons/ti";
import { LinkContainer } from "react-router-bootstrap";
import { toast } from "react-toastify";
import {
  getAllEmployees,
  resetEmployeeList,
  getEmployeeById,
  deleteEmployee,
  resetEmployeeDelete,
  resetEmployeeCreate,
} from "../features/employee/employeeSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import Print from "../components/Print";
import { logout } from "../features/user/userSlice";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFViewer,
} from "@react-pdf/renderer";

//Style for Print
const styles = StyleSheet.create({
  page: {
    flexDirection: "row",
    padding: "38",
  },
  section: {
    // margin: 20,
    // padding: 20,
    flexGrow: 1,
  },
  title: {
    fontSize: 25,
    fontWeight: "bold",
    color: "#3c8dbc",
    textAlign: "center",
    marginBottom: 10,
    fontFamily: "Helvetica-Bold",
  },
  header: {
    fontSize: 12,
    fontWeight: "bold",
    textAlign: "center",
    margin: 20,
    fontFamily: "Helvetica-Bold",
  },
  address: {
    fontSize: 10,
    textAlign: "center",
    marginBottom: 10,
  },
  tableContainer: {
    display: "flex",
    flexDirection: "column",
    overflowY: "auto",
  },
  footer: {
    position: "absolute",
    bottom: 0,
    left: 0,
    right: 0,
  },
  row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    // bottom: -100,
    // width: "20%",
    // position: "relative",
  },
  signatureLeft: {
    display: "flex",
    fontSize: 10,
    flexDirection: "column",
    // fontWeight: "bold",
    // color: "#3c8dbc",
    // textAlign: "center",
    fontFamily: "Helvetica",
    justifyContent: "flex-start",
    alignItems: "center",
    // bottom: 0,
    // position: "absolute",
  },
  signatureRight: {
    display: "flex",
    fontSize: 10,
    flexDirection: "column",
    // fontWeight: "bold",
    // color: "#3c8dbc",
    // textAlign: "right",
    fontFamily: "Helvetica",
    justifyContent: "flex-end",
    alignItems: "center",
    // bottom: 0,
    // position: "absolute",
  },
  line: {
    border: "1px dashed black",
    borderRadius: "1px",
    width: "150%",
  },
  table: {
    // display: "table",
    // width: "100%",
    // borderStyle: "solid",
    // borderWidth: 1,
    // borderCollapse: "collapse",
  },
  tableRow: {
    flexDirection: "row",
    borderBottom: 1,
    borderStyle: "dotted",
  },
  tableCell: {
    width: "33.33%",
    fontSize: "10",
    textAlign: "center",
    height: 25,
    margin: "auto",
    padding: 5,
    // borderStyle: "solid",
    // borderWidth: 1,
    fontFamily: "Helvetica-Bold",
  },
  tableData: {
    width: "33.33%",
    fontSize: "10",
    textAlign: "center",
    height: 25,
    margin: "auto",
    padding: 5,
    borderStyle: "dotted",
    borderBottom: 0,
  },
  tableCellO: {
    width: "12%",
    fontSize: "10",
    textAlign: "center",
    height: 25,
    margin: "auto",
    padding: 5,
    borderStyle: "dotted",
    borderBottom: 0,
    fontFamily: "Helvetica-Bold",
  },
  tableCell1: {
    width: "12%",
    fontSize: "10",
    textAlign: "center",
    height: 25,
    margin: "auto",
    padding: 5,
    borderStyle: "dotted",
    borderBottom: 0,
  },
  tableCellOO: {
    width: "40%",
    fontSize: "10",
    textAlign: "center",
    height: 25,
    margin: "auto",
    padding: 5,
    // borderStyle: "solid",
    // borderWidth: 1,
    fontFamily: "Helvetica-Bold",
  },
  tableCellO1: {
    width: "40%",
    fontSize: "10",
    textAlign: "center",
    height: 25,
    margin: "auto",
    padding: 5,
    // borderStyle: "solid",
    // borderWidth: 1,
  },
  // header: {
  //   fontSize: "20",
  //   textAlign: "center",
  //   margin: "20",
  // },
});

const OfficeAgentList = () => {
  // Print function
  // const handlePrint = useReactToPrint({
  //   content: () => componentRef.current,
  // });

  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [allEmployees, setAllEmployees] = useState([]);

  const [searchByName, setSearchByName] = useState("");
  const [searchByPhone, setSearchByPhone] = useState("");

  // const [preview, setPreview] = useState(false);
  const [printPreview, setPrintPreview] = useState(false);

  //user selector
  const { userInfo } = useSelector((state) => state.user);

  const {
    employees,
    isListLoading,
    isListError,
    isListSuccess,
    listErrorMessage,

    isDeleteError,
    isDeleteLoading,
    isDeleteSuccess,
    deleteErrorMessage,
  } = useSelector((state) => state.employee);

  useEffect(() => {
    if (!userInfo) {
      toast.error("Please Login To Get Access!!", { position: "top-center" });
      navigate("/login");
    }
    if (userInfo.permissions?.includes("employeeList") === false) {
      toast.error("Paknami Keno Koren???", {
        position: "top-center",
      });
      dispatch(logout());
    }
  }, [userInfo, navigate, dispatch]);

  useEffect(() => {
    if (isListError) {
      toast.error(listErrorMessage, { position: "top-center" });
    } else if (isListSuccess) {
      const filterdEmployees = employees
        .filter((employee) => {
          if (
            searchByName === "" ||
            employee.fullName.toLowerCase().includes(searchByName.toLowerCase())
          ) {
            return true;
          } else {
            return false;
          }
        })
        .filter((employee) => {
          if (
            searchByPhone === "" ||
            employee.phone.toLowerCase().includes(searchByPhone.toLowerCase())
          ) {
            return true;
          } else {
            return false;
          }
        });
      setAllEmployees(filterdEmployees);
    } else {
      dispatch(getAllEmployees());
    }
  }, [
    dispatch,
    isListError,
    isListSuccess,
    listErrorMessage,
    searchByName,
    searchByPhone,
    employees,
  ]);

  useEffect(() => {
    if (isDeleteError) {
      toast.error(deleteErrorMessage, { position: "top-center" });
    } else if (isDeleteSuccess) {
      toast.success("Employee Deleted Successfully", {
        position: "top-center",
      });
    }
  }, [isDeleteError, isDeleteSuccess, deleteErrorMessage]);

  useEffect(() => {
    return () => {
      dispatch(resetEmployeeList());
      dispatch(resetEmployeeDelete());
      //dispatch(resetOfficeAgentCreate());
    };
  }, []);

  const handleDelete = (id) => {
    if (
      window.confirm(
        "Are you sure you want to delete this agent? All data related to this agent will be deleted!"
      )
    ) {
      dispatch(deleteEmployee(id));
      dispatch(resetEmployeeList());
    }
  };

  return (
    <>
      {printPreview ? (
        <>
          <PDFViewer style={{ width: "100%", height: "100vh" }}>
            <Document>
              <Page size="A4" style={styles.page} orientation="landscape">
                <View style={styles.section}>
                  <Text style={styles.title}>Northeast Overseas LTD.</Text>
                  <Text style={styles.address}>
                    Gulfesha Plaza, 12/0, 69 Outer Circular Road, Boro Mogbazar,
                    Dhaka-1217
                  </Text>
                  <Text style={styles.address}>
                    Phone: +880241031411-2 || Email: info@northeastoverseas.com
                  </Text>
                  <Text style={styles.header}>EMPLOYEE LIST</Text>

                  <View style={styles.tableContainer}>
                    <View style={styles.table}>
                      <View style={styles.tableRow}>
                        <View style={styles.tableCellO}>
                          <Text>SL</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Name</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Phone</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Salary</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Commission</Text>
                        </View>
                        <View style={styles.tableCell}>
                          <Text>Loan</Text>
                        </View>
                        <View style={styles.tableCellOO}>
                          <Text>Deduction Ammount</Text>
                        </View>
                        <View style={styles.tableCellOO}>
                          <Text>Payable Ammount</Text>
                        </View>
                      </View>
                      {allEmployees.map((employee, index) => (
                        <View style={styles.tableRow} key={index}>
                          <View style={styles.tableCell1}>
                            <Text>{index + 1}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{employee.fullName}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{employee.phone}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{employee.salary}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{employee.commission}</Text>
                          </View>
                          <View style={styles.tableData}>
                            <Text>{employee.loan}</Text>
                          </View>
                          <View style={styles.tableCellO1}>
                            <Text>{employee.monthlyDeduction}</Text>
                          </View>
                          <View style={styles.tableCellO1}>
                            <Text>
                              {employee.salary +
                                employee.commission -
                                employee.monthlyDeduction}
                            </Text>
                          </View>
                        </View>
                      ))}
                    </View>
                  </View>

                  {/* Signature Section */}
                  <View style={styles.footer}>
                    <View style={styles.row}>
                      <View style={styles.signatureLeft}>
                        <hr style={styles.line} />
                        <Text style={{ marginTop: "5px" }}>
                          Agent Signature
                        </Text>
                      </View>

                      <View style={styles.signatureRight}>
                        <hr style={styles.line} />
                        <Text style={{ marginTop: "5px" }}>
                          Authorized Signature
                        </Text>
                      </View>
                    </View>
                  </View>
                </View>
              </Page>
            </Document>
          </PDFViewer>
          <Button variant="danger" onClick={() => setPrintPreview(false)}>
            Cancel
          </Button>
        </>
      ) : (
        <Container fluid className="my-4">
          <>
            <Row className="mb-4">
              <Card
                className="rounded-4 border"
                style={{ backgroundColor: "#e6edf1" }}
              >
                <h2 className="my-3 text-dark text-center fw-bold">
                  All <span style={{ color: "#5c91dc" }}>Employee</span> List
                </h2>
              </Card>
            </Row>

            <Row>
              {/* Search Options */}
              <CardGroup className="mb-2 p-0">
                <Card>
                  <Card.Header
                    className="text-center fw-bold text-black"
                    as="h6"
                    style={{ backgroundColor: "#74a2e3" }}
                  >
                    Search By Name
                  </Card.Header>
                  <Card.Body style={{ backgroundColor: "#74a2e3" }}>
                    <Form>
                      <Form.Control
                        type="text"
                        placeholder="Enter Name"
                        name="searchByName"
                        value={searchByName}
                        onChange={(e) => setSearchByName(e.target.value)}
                        className="shadow-rounded"
                      ></Form.Control>
                    </Form>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Header
                    className="text-center fw-bold text-black"
                    as="h6"
                    style={{ backgroundColor: "#74a2e3" }}
                  >
                    Search By Phone Number
                  </Card.Header>
                  <Card.Body style={{ backgroundColor: "#74a2e3" }}>
                    <Form>
                      <Form.Control
                        type="text"
                        placeholder="Enter Phone Number"
                        name="searchByPhone"
                        value={searchByPhone}
                        onChange={(e) => setSearchByPhone(e.target.value)}
                        className="shadow-rounded"
                      ></Form.Control>
                    </Form>
                  </Card.Body>
                </Card>
              </CardGroup>

              {/* <Row className="mb-3 mt-2"> */}
              {/* <Col className="mb-3 mt-2 d-flex justify-content-end">
                <Button
                  variant="outline-success"
                  className="fw-bold"
                  onClick={() => setPreview(true)}
                >
                  <TiPrinter className="mb-1" />
                  &nbsp; Print List
                </Button>
              </Col> */}
              <Col className="mb-3 mt-2 d-flex justify-content-end">
                <Button
                  variant="outline-success"
                  className="fw-bold"
                  onClick={() => setPrintPreview(true)}
                >
                  <TiPrinter className="mb-1" />
                  &nbsp; Print List
                </Button>
              </Col>

              {/* Table */}
              <Card className="shadow" style={{ backgroundColor: "#74a2e3" }}>
                <Card.Header
                  className="text-center text-black p-3 fw-bold"
                  as="h5"
                  style={{ backgroundColor: "#74a2e3" }}
                >
                  Employees List
                </Card.Header>
                <Table
                  rounded
                  bordered
                  hover
                  responsive
                  style={{ padding: "0px" }}
                >
                  <thead className="text-center">
                    <tr>
                      <th>No.</th>
                      <th>Image</th>
                      <th>Agent Name</th>
                      <th>Phone No.</th>
                      <th>Salary</th>
                      <th>Commission</th>

                      <th>Loan</th>
                      <th>Monthly Deduction</th>

                      <th>Payable Amount</th>

                      <th>Edit</th>
                      <th>Delete</th>
                      {/* <th>Print</th> */}
                    </tr>
                  </thead>
                  <tbody className="text-center">
                    {allEmployees.map((employee, index) => (
                      <>
                        <tr key={employee._id}>
                          <td style={{ padding: "0px" }}>{index + 1}</td>
                          <td style={{ padding: "0px" }}>
                            {employee.image ? (
                              <img
                                src={employee.image}
                                className="rounded"
                                style={{ width: "30px", height: "30px" }}
                              />
                            ) : (
                              <img
                                src="https://www.kindpng.com/picc/m/78-785827_user-profile-avatar
                          \-login-account-profile-user-icon-png.png"
                                className="rounded"
                                style={{ width: "30px", height: "30px" }}
                              />
                            )}
                          </td>
                          <td style={{ padding: "0px" }}>
                            {employee.fullName}
                          </td>
                          <td style={{ padding: "0px" }}>{employee.phone}</td>
                          <td style={{ padding: "0px" }}>{employee.salary}</td>
                          <td style={{ padding: "0px" }}>
                            {employee.commission}
                          </td>

                          <td style={{ padding: "0px" }}>{employee.loan}</td>
                          <td style={{ padding: "0px" }}>
                            {employee.monthlyDeduction}
                          </td>

                          <td style={{ padding: "0px" }}>
                            {employee.salary +
                              employee.commission -
                              employee.monthlyDeduction}
                          </td>

                          {userInfo?.userType === "admin" ? (
                            <>
                              <td style={{ padding: "0px" }}>
                                <LinkContainer
                                  to={`/updateOfficeAgent/${employee._id}`}
                                >
                                  <Button className="btn-sm">
                                    <FaEdit />
                                  </Button>
                                </LinkContainer>
                              </td>
                              <td style={{ padding: "0px" }}>
                                <Button
                                  className="btn-sm"
                                  variant="danger"
                                  onClick={() => handleDelete(employee._id)}
                                >
                                  <MdDelete />
                                </Button>
                              </td>
                            </>
                          ) : (
                            <>
                              <td style={{ padding: "0px" }}>
                                <LinkContainer to="">
                                  <Button className="btn-sm" disabled>
                                    <FaEdit />
                                  </Button>
                                </LinkContainer>
                              </td>
                              <td style={{ padding: "0px" }}>
                                <Button
                                  className="btn-sm"
                                  variant="danger"
                                  // onClick={() => handleDelete(employee._id)}
                                  disabled
                                >
                                  <MdDelete />
                                </Button>
                              </td>
                            </>
                          )}
                        </tr>
                      </>
                    ))}
                  </tbody>
                </Table>
              </Card>
            </Row>
          </>
        </Container>
      )}
    </>
  );
};

export default OfficeAgentList;
